import Grid from '@highcharts/grid-lite/es-modules/masters/grid-lite.src.js';
import { research } from '../ranking-sm/data.js';

/**
 * @param {string} id
 */
export default function gridResearch(id) {
    if (!document.getElementById(id)) return;

    Grid.grid(id, {
        dataTable: {
            columns: {
                "City": research.map(e => e.city),
                "Illegally parked<br>vehicles": research.map(e => `Vehicles in area: ${e.count.toLocaleString('en-US')}<br><i>(City-wide estimate: ${Math.round(e.count / (e.residentPercent / 100)).toLocaleString('en-US')})</i>`),
                "Study area": research.map(e => `${e.area}<br><i>(Area inhabited by approx. ${e.residentPercent}% of the city's population)</i>`),
                "Source": research.map(e => e.source)
            }
        },
        rendering: {
            rows: { strictHeights: false },
            theme: 'hcg-theme-default theme-compact'
        },
        columns: [{
            id: "City",
            cells: { className: 'bold' },
            width: 100
        }, {
            id: "Illegally parked<br>vehicles",
            cells: { format: '{value}' },
        }, {
            id: "Study area"
        }, {
            id: "Source"
        }]
    });
}
